import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "../Home/Home";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import CodingJourney from '../About/CodingJourney';
import AcademicDetails from '../About/AcademicDetails';

import Page404 from '../Errors/Page404';

import "./App.css";

const application = (
  <div className="inner-content pb-0">
    <div id="mask-bg"></div>
    <Header />
    <div id="route-render" className="container-fluid">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/engineering-journey" component={AcademicDetails}/>
        <Route path="/portfolio" component={CodingJourney} />
        <Route  component={Page404} />
      </Switch>
    </div>
  </div>
)
const  App = () => {
  return (
    <Router>
      <div className="main">
        {application}
      </div>
      <Footer />
    </Router>
  );
}

export default App;
